/**
 * Contains the different button types
 *
 * @author Jason Kelly [jk@interflora.dk](mailto:jk@interflora.dk)
 */
export enum ButtonType {
  /**
   * Button The button is a clickable button
   */
  Button = 'button',
  /**
   * Submit The button is a submit button (submits form-data)
   */
  Submit = 'submit',
  /**
   * The button is a reset button (resets the form-data to
   * its initial values)
   */
  Reset = 'reset',
}
